import { ScorecardStatus } from 'store/interfaces';
import {
  SCORECARD_STATUS_ACTIVE,
  SCORECARD_STATUS_FEEDBACK_REQUESTED,
  SCORECARD_STATUS_GOALS_APPROVED,
  SCORECARD_STATUS_GOALS_PREPARED,
} from 'constants/scorecards';

const ownerEditingStatuses: ScorecardStatus[] = [
  SCORECARD_STATUS_ACTIVE,
  SCORECARD_STATUS_GOALS_PREPARED,
  SCORECARD_STATUS_GOALS_APPROVED,
  SCORECARD_STATUS_FEEDBACK_REQUESTED,
];

export default function isOwnerScorecardEditingStatus(status: ScorecardStatus) {
  return ownerEditingStatuses.includes(status);
}
